window.Parsley = require('parsleyjs');

window.Parsley.addValidator('greaterThan', {
    requirementType: 'number',
    validateNumber: function(value, requirement, field) {
        return value > requirement;
    },
    messages: {
        en: 'This value must be greater than %s',
    },
});

window.Parsley.addValidator('greaterOrEqual', {
    requirementType: 'number',
    validateNumber: function(value, requirement, field) {
        return value >= requirement;
    },
    messages: {
        en: 'Must be greater or equal to %s',
    },
});



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap/parsley-custom-validators.js